import { render } from "./ProjectProgressBar.vue?vue&type=template&id=252e0c7a&scoped=true"
import script from "./ProjectProgressBar.vue?vue&type=script&lang=js"
export * from "./ProjectProgressBar.vue?vue&type=script&lang=js"

import "./ProjectProgressBar.vue?vue&type=style&index=0&id=252e0c7a&lang=postcss&scoped=true"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252e0c7a"]])

export default __exports__